// extracted by mini-css-extract-plugin
export default {"link":"ARJYcAKgUANpLu_DcBaV","restrictions":"xkxudafF0846Ehqbw_rH","restriction-notice":"bh8OQiadPRTJAur1ae6d","notice-audit":"X6J3O5AdBX6mNbeITXra"};